import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../traders.constants';

@Component({
  selector: 'app-traders-change-password-sent',
  templateUrl: './traders-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './traders-change-password-sent.component.css',
  ],
})
export class TradersChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}
}
